export default {
    fields: [
        {
            key: "_selected",
            label: "",
            sortable: false,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "id",
            label: "#",
            sorter: false,
            filter: false,
            _style: "width:10%",
            _filter: false,
            active: true
        },
        {
            key: "file_name",
            label: "name",
            sorter: false,
            filter: true,
            _style: "width:20%",
            _filter: true,
            active: true
        },
        {
            key: "name",
            label: "input",
            sorter: false,
            filter: false,
            _filter: true,
            active: true
        },
        {
            key: "total",
            label: "total",
            sorter: false,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "send",
            label: "send",
            sorter: false,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "ok",
            label: "ok",
            sorter: false,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "duplicated",
            label: "duplicated",
            sorter: false,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "error",
            label: "error",
            sorter: false,
            filter: false,
            _filter: false,
            active: true
        },
        {
            key: "activity",
            label: "activity",
            sorter: false,
            filter: false,
            _filter: false,
            active: true,
            _style: "width:5%",
            _import:false
        },
        {
            key: "created_at",
            label: "created_at",
            sorter: false,
            filter: false,
            _filter: false,
            active: true
        },
        
    ],
    allFields: [],
    items: [],
    order: "desc",
    rows: 10,
    page: 1,
    total_pages: 0,
    loading: true,
    pagination: true,
    sorter: true,
    responsive: true,
    columnFilter: {
        external: true,
        lazy: true
    },
    columnFilterValue: {},
    itemsPerPageSelect: true,
    itemSelected: null
}